import { message } from 'antd';

message.config({
    top: 72,
    duration: 3,
    maxCount: 3,
});

export const showSuccessMessage = (text) => {
    message.success(text);
};

export const showWarningMessage = (text) => {
    message.warning(text);
};

export const showErrorMessage = (text) => {
    message.error(text);
};
